import { render, staticRenderFns } from "./InputDate.vue?vue&type=template&id=36d9eb05&scoped=true&"
import script from "./InputDate.vue?vue&type=script&lang=js&"
export * from "./InputDate.vue?vue&type=script&lang=js&"
import style0 from "./InputDate.vue?vue&type=style&index=0&id=36d9eb05&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d9eb05",
  null
  
)

export default component.exports